const header = {
  definitions: 'ТЕРМІНИ',
  generalProvisions: 'ЗАГАЛЬНІ ПОЛОЖЕННЯ',
  subjectAndObligations: 'ПРЕДМЕТ ДОГОВОРУ',
  legalNature: 'ПРАВОВА ПРИРОДА ПОСЛУГИ ЗАРЯДЖАННЯ',
  costAndPayments: 'ВАРТІСТЬ ТА РОЗРАХУНКИ',
  tariffsAndFeatures: 'ТАРИФИ ТА МОЖЛИВОСТІ',
  stationOwnerDuties: 'ОБОВ’ЯЗКИ ВЛАСНИКА СТАНЦІЇ',
  liability: 'ВІДПОВІДАЛЬНІСТЬ',
  complaints: 'СКАРГИ ТА СПОРИ',
  confidentiality: 'КОНФІДЕНЦІЙНІСТЬ І ДАНІ',
  termAndOther: 'СТРОК, ЗМІНИ ТА РЕКВІЗИТИ',
};

const introduction = [
  'Цей Договір є публічною офертою та договором приєднання для власників зарядних станцій, які підключають обладнання до мережі 220-km.com.',
  'Сторони цього Договору: Замовник (власник зарядної станції) та Постачальник сервісу — ФОП Павлов Максим Валерійович, РНОКПП 3181213230. Замовник у сесіях на своїх станціях є Виконавцем для водія і отримує оплату від водія на свій рахунок. Постачальник сервісу надає технічний доступ до Платформи та API під Банк.',
  'м. Київ',
];

export const companyInfo = {
  name: 'ФОП Павлов Максим Валерійович',
  fullName: 'ФІЗИЧНА ОСОБА-ПІДПРИЄМЕЦЬ ПАВЛОВ МАКСИМ ВАЛЕРІЙОВИЧ',
  shortName: 'ФОП Павлов М.В.',
  edrpou: '3181213230',
  address: '02160, Україна, місто Київ, проспект Соборності, будинок 17 офіс 2-92',
  bankAccount: 'UA563220010000026004300057390',
  bankName: 'АТ «УНІВЕРСАЛ БАНК»',
  bankMfo: '322001',
  bankCode: '21133352',
  email: 'sales@220-km.com',
  phone: '+380982204411',
};

const body = [
  {
    id: 1,
    title: header.definitions,
    href: '#definitions',
    texts: [
      {
        id: '1.1',
        text: 'Замовник / Власник станції / Виконавець — особа, яка підключає зарядну станцію до 220-km.com і в зарядних сесіях на своїх станціях є надавачем Послуги заряджання для водія. Водій сплачує Виконавцю безпосередньо через еквайринг банку.',
      },
      {
        id: '1.2',
        text: 'Постачальник сервісу / Агрегатор — Фізична особа-підприємець Павлов Максим Валерійович, РНОКПП 3181213230, адреса: 02160, Україна, місто Київ, проспект Соборності, будинок 17 офіс 2-92. Надає Замовнику технічний доступ до кабінету, API під Банк і запуск сесій. Не є надавачем Послуги заряджання для водія і не отримує оплату від водія, крім своєї комісії за користування Платформою.',
      },
      {
        id: '1.3',
        text: 'Платформа — 220-km.com, кабінет 220-km.com/b2b, API та пов’язані сервіси моніторингу, білінгу та запуску сесій.',
      },
      {
        id: '1.4',
        text: 'API 220-km.com під Банк — технічний сервіс інтеграції кабінету Замовника з банком для онлайн-оплати та оплати за QR на станції.',
      },
      {
        id: '1.5',
        text: 'Банк — АТ «УНІВЕРСАЛ БАНК», який надає Замовнику послугу еквайрингу. Постачальник сервісу не приймає і не зберігає кошти водіїв.',
      },
      {
        id: '1.6',
        text: 'Власник локації — особа, якій належить місце розміщення станції. Energy Cost Bearer — особа, яка фактично оплачує електроенергію для станції. Одна особа може виконувати кілька ролей.',
      },
      {
        id: '1.7',
        text: 'Послуга заряджання — комплексна послуга, яку водій отримує на станції. Для водія це послуга заряджання, а не купівля електроенергії як товару.',
      },
      {
        id: '1.8',
        text: 'Аванс — сума переплати Клієнтів Замовника (водіїв), розмір якої перевищує вартість фактично наданих послуг заряджання. Аванс обліковується на Платформі і використовується для подальших взаєморозрахунків. Після припинення надання послуг Аванс підлягає поверненню.',
      },
    ],
  },
  {
    id: 2,
    title: header.generalProvisions,
    href: '#generalProvisions',
    texts: [
      {
        id: '2.1',
        text: 'Договір є публічною офертою за ст. 633, 634, 641 Цивільного кодексу України. Акцепт — підключення еквайрингу Банку для станцій, підключених до Платформи, або початок отримання виплат / користування кабінетом після публікації цієї редакції.',
      },
      {
        id: '2.2',
        text: 'Замовник підтверджує, що йому виповнилося 18 років і він має право розпоряджатися станцією та локацією (або має згоду власника локації).',
      },
      {
        id: '2.3',
        text: 'Умови однакові для всіх Замовників, крім індивідуальних умов у кабінеті, на сторінці тарифів або в окремій угоді.',
      },
    ],
  },
  {
    id: 3,
    title: header.subjectAndObligations,
    href: '#subjectAndObligations',
    texts: [
      {
        id: '3.1',
        text: 'Постачальник сервісу надає технічний доступ до Платформи та API 220-km.com під Банк (КВЕД 63.11): запуск сесій, відображення тарифів, статистика, інтеграція з еквайрингом. Це послуги технічного характеру. Закон України «Про платіжні послуги» до них не застосовується (п. 8 ч. 1 ст. 9).',
      },
      {
        id: '3.2',
        text: 'Послугу еквайрингу надає виключно Банк на своїх умовах. Постачальник сервісу не має доступу до коштів Замовника і не є стороною відносин «водій — Банк».',
      },
      {
        id: '3.3',
        text: 'Сервіс надається «як є». Постачальник сервісу не гарантує безперервності роботи, якщо збій стався через Банк, інтернет, електромережу, обладнання Замовника, війну, дії влади чи інші обставини поза його контролем.',
      },
      {
        id: '3.4',
        text: 'Права інтелектуальної власності на Платформу і API належать Постачальнику сервісу. Замовник отримує лише право користування на час дії Договору.',
      },
    ],
  },
  {
    id: 4,
    title: header.legalNature,
    href: '#legalNature',
    texts: [
      {
        id: '4.1',
        text: 'Водій сплачує єдину плату за послугу заряджання. Облік у кВт·год потрібен для розрахунку, а не для продажу електроенергії водію як товару.',
      },
      {
        id: '4.2',
        text: 'Відповідно до ч. 5 ст. 58 Закону України «Про ринок електричної енергії» заряджання електромобілів на ЕЗС є споживанням електроенергії, а не її постачанням.',
      },
      {
        id: '4.3',
        text: 'Компенсація вартості електроенергії Energy Cost Bearer, частка Власника станції чи Власника локації — внутрішній розподіл виручки. Це не змінює природу послуги для водія і не робить жодну сторону постачальником електроенергії водію, якщо закон прямо не вимагає іншого.',
      },
      {
        id: '4.4',
        text: 'Замовник самостійно забезпечує законну модель живлення станції (власний облік, договір з постачальником, компенсація орендодавцю тощо) і не формулює оферту водіям як продаж кВт·год електроенергії.',
      },
    ],
  },
  {
    id: 5,
    title: header.costAndPayments,
    href: '#costAndPayments',
    texts: [
      {
        id: '5.1',
        text: 'Плата Постачальника сервісу — комісія від суми транзакції водія: 5%, 7% або 9% залежно від тарифного плану (розділ 6).',
      },
      {
        id: '5.2',
        text: 'Замовник доручає Банку в день відшкодування транзакцій переказувати комісію на рахунок Постачальника сервісу. Комісія Банку за еквайринг сплачується окремо за тарифами Банку.',
      },
      {
        id: '5.3',
        text: 'Акт наданих послуг Сторони можуть підписати до 15 числа наступного місяця, якщо Замовник підготує проєкт акта.',
      },
      {
        id: '5.4',
        text: 'Постачальник сервісу може змінювати вартість своїх послуг із попереднім повідомленням і може окремо брати плату з водіїв, якщо це показано в інтерфейсі до сесії.',
      },
    ],
  },
  {
    id: 6,
    title: header.tariffsAndFeatures,
    href: '#tariffsAndFeatures',
    texts: [
      {
        id: '6.1',
        text: 'Базовий — 5% від транзакції, доступне бронювання порту для водіїв.',
      },
      {
        id: '6.2',
        text: 'Про — 7% від транзакції.',
      },
      {
        id: '6.3',
        text: 'Про+ — 9% від транзакції: динамічний тариф від SoC або РДН, інтеграція з Вирій EMS, роумінг.',
      },
      {
        id: '6.4',
        text: 'Порівняння планів — на сторінці 220-km.com/b2b. План обирається при підключенні або за домовленістю. Зміна плану — після повідомлення Замовника.',
        linkUrl: 'https://220-km.com/b2b',
        linkLabel: '220-km.com/b2b',
      },
    ],
  },
  {
    id: 7,
    title: header.stationOwnerDuties,
    href: '#stationOwnerDuties',
    texts: [
      {
        id: '7.1',
        text: 'Замовник забезпечує справність станції, безпечний монтаж, живлення, заземлення, облік електроенергії та відповідність обладнання нормам. Мінімальна технічна вимога до підключення — стабільний OCPP 1.6J, якщо інше не погоджено.',
      },
      {
        id: '7.2',
        text: 'У кабінеті Замовник заповнює адресу, тарифи, потужність, конектори, доступність і платіжні реквізити. Тариф, який бачить водій до сесії, має відповідати цим даним.',
      },
      {
        id: '7.3',
        text: 'Замовник самостійно відповідає за податки, ліцензії, дозвільні документи, безпеку на локації як надавач Послуги заряджання водію, а також за заборонені платіжними системами товари й послуги: https://www.liqpay.ua/prohibited_goods.',
      },
      {
        id: '7.4',
        text: 'Якщо Замовник не є власником локації, він забезпечує право розміщення станції та доступ для монтажу, сервісу й демонтажу.',
      },
    ],
  },
  {
    id: 8,
    title: header.liability,
    href: '#liability',
    texts: [
      {
        id: '8.1',
        text: 'Постачальник сервісу не є стороною відносин «водій — Замовник», «водій — Банк», «Замовник — Банк» і не відповідає за технічний стан станцій Замовника.',
      },
      {
        id: '8.2',
        text: 'Відповідальність Постачальника сервісу обмежується сумою останньої комісії, сплаченої Замовником. Відшкодування збитків не здійснюється, крім випадків, коли обмеження заборонене законом.',
      },
      {
        id: '8.3',
        text: 'Якщо через порушення Замовником правил платіжних систем або Банку до Постачальника сервісу застосують штрафи, Замовник компенсує їх у регресному порядку.',
      },
      {
        id: '8.4',
        text: 'У разі несплати комісії, шахрайства або небезпечної чи несправної станції Постачальник сервісу може обмежити відображення станції, запуск сесій або виплати до усунення порушення.',
      },
      {
        id: '8.5',
        text: 'У випадку самовільного від’єднання Замовником зарядних станцій від програмного забезпечення онлайн-сервісів Платформи 220-km.com без попереднього письмового повідомлення Постачальника сервісу, Замовник зобов’язується сплатити штраф у трикратному розмірі комісії Постачальника сервісу за попередній місяць, перед яким було здійснено самовільне від’єднання зарядних станцій.',
      },
    ],
  },
  {
    id: 9,
    title: header.complaints,
    href: '#complaints',
    texts: [
      {
        id: '9.1',
        text: 'Скарги щодо сервісу надсилайте на sales@220-km.com протягом 48 годин з описом обставин. Відповідь — протягом 15 робочих днів.',
      },
      {
        id: '9.2',
        text: 'Застосовується право України. Спори спочатку вирішують переговорами, а якщо згоди немає — у суді відповідно до законодавства України.',
      },
    ],
  },
  {
    id: 10,
    title: header.confidentiality,
    href: '#confidentiality',
    texts: [
      {
        id: '10.1',
        text: 'Замовник дає згоду на обробку даних кабінету та станцій для виконання Договору згідно із Законом України «Про захист персональних даних».',
      },
      {
        id: '10.2',
        text: 'Дані не передаються третім особам без потреби виконання Договору, вимог закону або платіжної інфраструктури.',
      },
      {
        id: '10.3',
        text: 'Замовник надає 220-km.com (Постачальнику сервісу) право публікувати кейси B2B-співпраці на Платформі та в матеріалах про співпрацю без імені, назви компанії та інших персональних даних Замовника. Публікація із зазначенням імені або інших персональних даних можлива лише за окремою письмовою згодою Замовника.',
      },
    ],
  },
  {
    id: 11,
    title: header.termAndOther,
    href: '#termAndOther',
    texts: [
      {
        id: '11.1',
        text: 'Договір діє з акцепту до повного виконання зобов’язань. Кожна зі Сторін може припинити Договір, письмово повідомивши іншу Сторону не менше ніж за 1 (один) місяць до дати припинення. Постачальник сервісу може припинити Договір без цього строку і без компенсації в разі істотного порушення.',
      },
      {
        id: '11.2',
        text: 'Нова редакція діє з моменту публікації на Платформі, якщо інший строк не вказано. Подальше користування кабінетом або отримання виплат означає прийняття змін.',
      },
      {
        id: '11.3',
        text: 'Постачальник сервісу є платником єдиного податку третьої групи і не є платником ПДВ.',
      },
      {
        id: '11.4',
        text: 'Після припинення надання послуг Аванс підлягає поверненню. Якщо Аванс не повернуто після припинення надання послуг, нараховується пеня у розмірі 22% річних від суми неповернутого Авансу.',
      },
      {
        id: '11.5',
        text: 'Реквізити: ФОП Павлов Максим Валерійович, РНОКПП 3181213230, IBAN UA563220010000026004300057390, АТ «УНІВЕРСАЛ БАНК», МФО 322001, sales@220-km.com, +380982204411.',
      },
    ],
  },
];

const structureDocument = {
  header,
  introduction,
  body,
};

export default structureDocument;
